import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { Tab } from "@headlessui/react";
// import District from "./District/index";
// import Region from "./Region/index";
// import Area from "./Area/index";

// import Territory from "./Territory";
import { Link } from "react-router-dom";
import {
  OfficeHierarchyTabs,
  OfficeTabs,
} from "./UtilitiesOfficeHierarchyTabs";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import React, { useState, useEffect } from "react";

const OfficeHierarchyConfiguration = ({ children }) => {
  const { pathname } = useLocation();
  const userPermissions = useRecoilValue(permissionsSelector);

  const currentTabs = OfficeHierarchyTabs.filter((tabs) =>
    userPermissions.includes(tabs.permission)
  );
  const calculateDefaultTab = currentTabs
    .filter((c) => c.path === pathname)
    .map((x) => x.index);
  const [hover, setHover] = useState();
  const [distributedTabs, setDistributedTabs] = useState([]);
  const distributeTabs = (arrayToDistribute, numOfArray) => {
    var array = [];
    for (var i = 0; i < arrayToDistribute.length; i++) {
      array[i % numOfArray]
        ? array[i % numOfArray].push(i)
        : (array[i % numOfArray] = [i]);
    }

    setDistributedTabs(array);
  };

  useEffect(() => {
    if (distributedTabs.length === 0) {
      distributeTabs(currentTabs, 3);
    }
  }, [currentTabs, distributedTabs]);

  return (
    <Router>
      <Tab.Group defaultIndex={calculateDefaultTab}>
        <Tab.List className="mt-0 tabUpperShadow ">
          <div className="px-4 pt-2 space-y-5">
            <h1 className="titleDiv">OFFICE HIERARCHY CONFIGURATION</h1>
            {OfficeHierarchyTabs.map((item, index) =>
              userPermissions.includes(item.permission) ? (
                <Tab key={index ? index : 0}>
                  {({ selected }) => (
                    <div className="w-full">
                      <div
                        style={{
                          zIndex: selected
                            ? currentTabs.length + 1
                            : hover === index
                            ? currentTabs.length + 2
                            : currentTabs.length - index,
                        }}
                        onMouseEnter={() => setHover(index)}
                        onMouseLeave={() => setHover(undefined)}
                        className={`inline-block text-white whitespace-nowrap px-1 py-2 font-bold
           uppercase text-xs1 cursor-pointer tracking wide relative rounded-t-2xl w-full hover:min-w-max 
           hover:bg-pink-500 
        
            ${
              distributedTabs[0]?.includes(index)
                ? index !== 0
                  ? index === currentTabs.length - 1
                    ? "bg-tabColorLightBlue tab-leftLight"
                    : "bg-tabColorLightBlue tab-rightLight tab-leftLight"
                  : "bg-tabColorLightBlue tab-rightLight"
                : distributedTabs[1]?.includes(index)
                ? index === currentTabs.length - 1
                  ? "bg-tabColorNavyBlue tab-leftNavy"
                  : "bg-tabColorNavyBlue tab-rightNavy tab-leftNavy"
                : distributedTabs[2]?.includes(index)
                ? index === currentTabs.length - 1
                  ? "bg-tabColorDarkBlue tab-leftDark"
                  : "bg-tabColorDarkBlue tab-rightDark tab-leftDark"
                : ""
            } 
              ${selected && "min-w-max bg-selectedPurple text-white"}
              ${
                selected && index === 0
                  ? "tab-rightfirstSelected"
                  : selected && index === currentTabs.length - 1
                  ? "tab-leftlastSelected"
                  : selected && index !== 0 && index !== currentTabs.length - 1
                  ? "tab-rightSelected tab-leftSelected"
                  : ""
              }
             `}
                      >
                        <Link
                          key={index ? index : 0}
                          to={
                            item.path
                              ? item.path
                              : "/OfficeHierarchyConfiguration"
                          }
                        >
                          {item.title}
                        </Link>
                      </div>
                    </div>
                  )}
                </Tab>
              ) : null
            )}
          </div>
        </Tab.List>
        <Tab.Panels className="">
          {OfficeHierarchyTabs.map(
            (child) =>
              userPermissions.includes(child.permission) && (
                <Tab.Panel key={child.path}>
                  {React.createElement(child.component)}
                </Tab.Panel>
              )
          )}
        </Tab.Panels>
      </Tab.Group>
    </Router>
  );
};

export default OfficeHierarchyConfiguration;
